import TreeTable from './src'

TreeTable.install = Vue => {
  Vue.component(TreeTable.name, TreeTable)
}

export default TreeTable
